import type { CrowdexCollaboration } from '@crowdex/agent-contracts';
import type { PluginConversationContext } from '@crowdex/host-kit/host';
import { GroupConversation } from '@/features/groups/group-conversation';
import { PluginBoundary } from './native-plugin-panel';

function Group(props: PluginConversationContext) {
  return (
    <PluginBoundary>
      <GroupConversation {...props} />
    </PluginBoundary>
  );
}

/**
 * A group's conversation: its members' words, by who said them, and the group's composer. A
 * project's conversation is an ordinary one, led by its agent.
 */
export function useGroupConversation(collaboration: CrowdexCollaboration) {
  return collaboration === 'group' ? Group : undefined;
}
